import logger from '../utils/logger';
import { storage } from '../utils/storage';

let API_BASE_URL;
let configLoadPromise;

async function loadConfig() {
    try {
        const response = await fetch('/api/config', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
            cache: 'no-cache',
        }); 
        
        if (!response || !response.ok) {
            const status = response?.status || 'Unknown';
            throw new Error(`HTTP error! status: ${status}`); 
        }

        const configData = await response.json();
        
        if (!configData || typeof configData.apI_BASE_URL !== 'string') {
            throw new Error('Invalid configuration data received');
        }
        
          API_BASE_URL = `${configData.apI_BASE_URL}api`;
         //   API_BASE_URL = 'https://localhost:5001/api';
        logger.info('Configuration loaded successfully');
       
    } catch (error) {
        logger.error('Failed to load configuration:', error);
        // Fallback to default if available
        if (process.env.REACT_APP_API_BASE_URL) {
            API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}api`;
            logger.warn('Using fallback API URL from environment variable');
        } else {
            throw error; // Re-throw to prevent silent failures
        }
    }
}

configLoadPromise = loadConfig();

async function getAuthHeader() {
    try {
        await configLoadPromise;
        
        if (!API_BASE_URL) {
            throw new Error('API_BASE_URL is not configured. Please wait for configuration to load.');
        }
        
        const token = storage.getItem('token');

        if (!token || typeof token !== 'string' || token.trim() === '') {
            const error = new Error('UNAUTHORIZED: JWT token not found.');
            error.isAuthError = true;
            logger.warn('Authentication token not found');
            throw error;
        }

        // Sanitize token to prevent injection
        const sanitizedToken = token.trim();

        return {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${sanitizedToken}`
        };
    } catch (error) {
        logger.error('Error getting auth header:', error);
        throw error;
    }
}

export { API_BASE_URL, getAuthHeader };
